import { Injectable } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import 'devextreme/data/odata/store';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Utilities } from '../utilities';

@Injectable({
  providedIn: 'root'
})

export abstract class ParentsPortalBaseService<T> {

  abstract route: string;
  orderBy = '';

  headers = new HttpHeaders({ 
    'token': this.utilitiesService.getToken()//,
    //'Authorization': 'Basic ' + btoa('essuser:XpSmQfHbEVb0rXG1QuGD6iXLy')
  });
  

  private get orderByQuery(): string {
    return this.orderBy === '' ? '' : '?$orderby=' + this.orderBy;
  }



  constructor(protected httpClient: HttpClient,
    private utilitiesService:Utilities) { }

  get(): any {
    return this.httpClient.get<any>(this.utilitiesService.baseAPIUrl + `${this.route}`, {headers:this.headers} );
  }

  getSingle(id: Number, query = ''): any {
    return this.httpClient.get<any>(this.utilitiesService.baseAPIUrl + `${this.route}(${id})${query}`, {headers:this.headers});
  }

  getSingleRecordByID(query: string): any {
    return this.httpClient.get<any>(this.utilitiesService.baseAPIUrl +  query, {headers:this.headers});
  }

  utilitiesGet(query: string): any {
    return this.httpClient.get<any>(this.utilitiesService.baseAPIUrl + `${this.route}` + query,{headers:this.headers});
  }

  utilitiesPost(query: string, requestBody: any): any {
    return this.httpClient.post<any>(this.utilitiesService.baseAPIUrl + `${this.route}`   + query, requestBody,{headers:this.headers});
  }


  searchNonOdata(query: string): any {
    return this.httpClient.get<any>(this.utilitiesService.baseAPIUrl +  query,{headers:this.headers});
  }

  search(query: string): DataSource {
    return new DataSource({
      store: {
        type: 'odata',
        version: 4,
        url: this.utilitiesService.baseAPIUrl +  query
      }
    });
  }

  save(record: T) {
    return this.httpClient.post<any>(this.utilitiesService.baseAPIUrl + `${this.route}`, record);
  }

  delete(id: Number) {
    return this.httpClient.delete<any>(this.utilitiesService.baseAPIUrl + `${this.route}(${id})`);
  }

  public get oDataSource(): DataSource {
    return new DataSource({
      store: {
        type: 'odata',
        version: 4,
        url: this.utilitiesService.baseAPIUrl + `${this.route}${this.orderByQuery}`
      }
    });
  }
}
